// Copyright 2025, University of Maryland, All Rights Reserved
import type { NodeApiClient } from '@/app-shell/services'
import type {
  WorkspaceCloneRequest,
  WorkspaceCloneResponse,
} from './types'

/** Clones a workspace from source to target organization/workspace. */
export async function clone(
  client: NodeApiClient,
  sourceOrgId: string,
  sourceWorkspaceId: string,
  payload: WorkspaceCloneRequest,
): Promise<WorkspaceCloneResponse> {
  const axios = client.getAxiosInstance()

  const response = await axios.post<WorkspaceCloneResponse>(
    `/admin/bootstrap/workspace/${sourceWorkspaceId}/clone`,
    { format: 'yaml', clean: false, ...payload },
    { params: { org_id: sourceOrgId } },
  )

  return response.data
}

/** Service interface for Services facade compatibility. */
export interface WorkspaceTransferService {
  clone: (sourceOrgId: string, sourceWorkspaceId: string, payload: WorkspaceCloneRequest) => Promise<WorkspaceCloneResponse>
}

/** Creates a service object with client bound to all methods. */
export function createWorkspaceTransferService(client: NodeApiClient): WorkspaceTransferService {
  return {
    clone: (sourceOrgId, sourceWorkspaceId, payload) => clone(client, sourceOrgId, sourceWorkspaceId, payload),
  }
}
